module.exports = __webpack_public_path__ + "img/amexlogopng-1578907833580.540357a3.png";